import React, { ReactElement } from "react";

import clsx from "clsx";

export default function SubHeaderFilters({
  children,
}: React.PropsWithChildren) {
  return (
    <div
      className={clsx(
        "flex w-full pr-4 items-center justify-start bg-neutral-00 p-4 gap-2 flex-wrap"
      )}
    >
      {children}
    </div>
  );
}
